import React from "react";
import style from "./welcome.module.css";
import TestParssed from "./TestPassed";

const WelcomeComponent = ({ start, isCompleted }) => {
  if (isCompleted) {
    return <TestParssed />;
  }
  return (
    <section className={style.main}>
      <h2>Приветствуем Вас на нашем портале</h2>
      <p>
        Пожалуйста ответьте на несколько вопросов, нам важно знать Ваше мнение!
      </p>
      <button
        onClick={() => {
          start(true);
        }}
      >
        Начать
      </button>
    </section>
  );
};

export default WelcomeComponent;
